<!-- CameraRect.vue -->
<template>
  <div class="camera">
    <button class="back-btn" @click="goBack">返回</button>
    <video ref="video" autoplay playsinline></video>
    <div class="wrapper">
    <div class="frame"></div>
  </div>

    <!-- 拍照按钮 -->
    <button class="snap-btn" @click="takePhoto">拍照</button>
  </div>
</template>

<script setup>
  import { onMounted, ref } from 'vue'

  const emit = defineEmits(['photoFile']) // 改名，语义更清晰
  const video = ref()

  onMounted(() => {
    navigator.mediaDevices
      .getUserMedia({ video: { facingMode: 'environment' } })
      .then(stream => (video.value.srcObject = stream))
  })

  function takePhoto() {
    const canvas = document.createElement('canvas')
    canvas.width = video.value.videoWidth
    canvas.height = video.value.videoHeight
    canvas.getContext('2d').drawImage(video.value, 0, 0)

    // 关键：canvas → Blob → File
    canvas.toBlob(
      blob => {
        const file = new File([blob], 'photo.jpg', { type: 'image/jpeg' })
        emit('photoFile', file)
      },
      'image/jpeg',
      0.9
    )
  }
  function goBack () {
  video.value.srcObject?.getTracks().forEach(t => t.stop())
  emit('close')      // 通知父组件关闭
}
</script>

<style scoped>
  .camera {
    position: fixed;
    inset: 0;
    background: #000;
    z-index: 9999;
  }
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .back-btn {
  position: fixed;   /* 相对视口定位 */
  top: 20px;
  left: 20px;
  z-index: 999;      /* 确保在最上层 */
  padding: 8px 16px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}
  .wrapper{
  position: fixed;      /* 脱离文档流，可随意定位 */
  top: 50%;             /* 垂直居中起点 */
  left: 0;              /* 水平占满 */
  width: 100%;
  height: 300px;
  transform: translateY(-50%); /* 垂直真正居中 */
  pointer-events: none; /* 避免拦截点击（可删） */
}

/* 子元素：16:5 取景框，水平垂直居中于父元素 */
.frame{
  width: auto;                /* 占满父元素 300 px 高 */
  aspect-ratio: 16 / 5;       /* 宽度 = 300 * 16 / 5 = 960 px */
  margin: 50px auto 0;             /* 水平居中 */
  border: 2px solid #fff;
  box-sizing: border-box;
  pointer-events: auto;       /* 如需在框上交互，改回 auto */
}
.snap-btn {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);

  /* 外圆 */
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #fff;
  border: 4px solid rgba(0, 0, 0, 0.4);

  /* 内圆 */
  box-shadow: inset 0 0 0 2px #000;
  cursor: pointer;
  transition: transform 0.08s;
}

/* 按下瞬间缩小，模拟真实快门反馈 */
.snap-btn:active {
  transform: translateX(-50%) scale(0.9);
}
</style>
